const firebaseConfig = {
    apiKey: "AIzaSyDtgqmt8VE7kgu8yWo2Rw8MEVjVT64ujWA",
    authDomain: "yokohama-city-youchien-staging.firebaseapp.com",
    projectId: "yokohama-city-youchien-staging",
    storageBucket: "yokohama-city-youchien-staging.appspot.com",
    messagingSenderId: "814062271658",
    appId: "1:814062271658:web:f34ab0dd0da4da56a764d3"
  };

  export default firebaseConfig;